import React from "react";
import styled from "styled-components";

const Styled = styled.div`
  color: #666;
  line-height: 2rem;
  font-size: 1.1rem;

  a {
    color: #006699;
    text-decoration: none;
  }
`;

const Copyright = () => {
  return (
    <Styled>
      TCMPC Curriculum Platform © 2024{" "}
      <a href="https://examspark.com" target="_blank" rel="noreferrer">
        ExamSpark Inc
      </a>
      . Curriculum Content © 2024{" "}
      <a href="https://www.tcmpc.org/" target="_blank" rel="noreferrer">
        Texas Curriculum Management Program Cooperative
      </a>
      . All rights reserved.
    </Styled>
  );
};

export default Copyright;
